import ApiService from "../../../ApiService";

const ListService = {
    loadScreenView: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/loadscreenview", { SearchErrorInVO }, successCallback, failureCallback);
    },

    loadData: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/loaddata", SearchErrorInVO, successCallback, failureCallback);
    },

    deleteByErrorMessage: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/deletebyerrormessage", SearchErrorInVO, successCallback, failureCallback);
    },

    setClientErrorPriorityByErrorMessage: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/setprioritybyerrormessage", SearchErrorInVO, successCallback, failureCallback);
    },

    setClientErrorStatusByErrorMessage: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/setstatusbyerrormessage", SearchErrorInVO, successCallback, failureCallback);
    },

    setClientErrorTaskByErrorMessage: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/settaskbyerrormessage", SearchErrorInVO, successCallback, failureCallback);
    },

    deleteApiErrorByErrorClass: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/deletebyerrorclass", SearchErrorInVO, successCallback, failureCallback);
    },

    setApiErrorPriorityByErrorClass: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/setprioritybyerrorclass", SearchErrorInVO, successCallback, failureCallback);
    },

    setApiErrorStatusByErrorClass: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/setstatusbyerrorclass", SearchErrorInVO, successCallback, failureCallback);
    },

    setApiErrorTaskErrorClass: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/settaskbyerrorclass", SearchErrorInVO, successCallback, failureCallback);
    },

    notifyOnCallMember: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/dashboard/notifyoncall", SearchErrorInVO, successCallback, failureCallback);
    },
};

export default ListService;
